import React, { Component } from 'react';
import CountUp from 'react-countup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './welcome.scss';

export default class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = { daysAsDeveloperEnd: 0 , noOfProjectsEnd: 0, companiesWorkedEnd: 0, countriesWorkedEnd: 0 };
  }
  
  calculateTotalDaysAsDeveloper() {
    var startDate = new Date('2003/10/03 00:00:00');
    var today = new Date();
    var start = Math.floor(startDate.getTime() / (3600 * 24 * 1000));
    var end = Math.floor(today.getTime() / (3600 * 24 * 1000));
    return end - start;
  };

  componentDidUpdate(prevProps) {
    if (this.props.isVisible !== prevProps.isVisible) {
      if (this.props.isVisible) {
        this.setState({
          daysAsDeveloperEnd: this.calculateTotalDaysAsDeveloper(),
          noOfProjectsEnd: 35,
          companiesWorkedEnd: 9,
          countriesWorkedEnd: 3
        });
      } else {
        this.setState({
          daysAsDeveloperEnd: 0,
          noOfProjectsEnd: 3500,
          companiesWorkedEnd: 400,
          countriesWorkedEnd: 500
        });
      }
    }
  }

  render() {
    return (
      <div id="welcome" className="wellcome-area">
        <div className="well-bg">
          <div className="container">
            <div className="row">
              <div className="dev-summary-card col-6 col-sm-3">
                <div className="title small">Days as a developer</div>
                <div className="icon"><FontAwesomeIcon icon="laptop-code" /></div>
                <CountUp
                  className="count"
                  start={0}
                  end={this.state.daysAsDeveloperEnd}
                  duration={2.75}
                  useEasing={true}
                  useGrouping={true}
                  separator=" "
                  prefix=""
                  suffix=""
                />
              </div>
              <div className="dev-summary-card col-6 col-sm-3">
                <div className="title small">Number of projects</div>
                <div className="icon"><FontAwesomeIcon icon="project-diagram" /></div>
                <CountUp
                  className="count"
                  start={3400}
                  end={this.state.noOfProjectsEnd}
                  duration={2.75}
                  useEasing={true}
                  useGrouping={true}
                  separator=" "
                  prefix=""
                  suffix=""
                />
              </div>
              <div className="dev-summary-card col-6 col-sm-3">
                <div className="title small">Companies worked</div>
                <div className="icon"><FontAwesomeIcon icon="building" /></div>
                <CountUp
                  className="count"
                  start={8000}
                  end={this.state.companiesWorkedEnd}
                  duration={2.75}
                  useEasing={true}
                  useGrouping={true}
                  separator=" "
                  prefix=""
                  suffix=""
                />
              </div>
              <div className="dev-summary-card col-6 col-sm-3">
                <div className="title small">Countries worked</div>
                <div className="icon"><FontAwesomeIcon icon="globe-asia" /></div>
                <CountUp
                  className="count"
                  start={3000}
                  end={this.state.countriesWorkedEnd}
                  duration={2.75}
                  useEasing={true}
                  useGrouping={true}
                  separator=" "
                  prefix=""
                  suffix=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.js